export const appLinks = [
  {
    rel: 'noreferrer',
    linkURL: 'https://app.appsflyer.com/id1008861332?pid=Website&c=Footer-iOS',
    target: '_blank',
    iconName: 'appleApp'
  },
  {
    rel: 'noreferrer',
    linkURL:
      'https://app.appsflyer.com/com.ingenio.keen?pid=Website&c=Footer-android',
    target: '_blank',
    iconName: 'androidApp'
  }
];

export const socialLinks = [
  {
    rel: 'noreferrer',
    linkURL: 'https://www.facebook.com/Keenpsychics',
    target: '_blank',
    iconName: 'facebook'
  },
  {
    rel: 'noreferrer',
    linkURL: 'https://twitter.com/KeenPsychic',
    target: '_blank',
    iconName: 'twitter'
  },
  {
    rel: 'noreferrer',
    linkURL: 'https://www.pinterest.com/keenpsychics',
    target: '_blank',
    iconName: 'pinterest'
  },
  {
    rel: 'noreferrer',
    linkURL: 'https://www.instagram.com/keenpsychics',
    target: '_blank',
    iconName: 'instagram'
  }
];
